import React from "react";
import Cms from "./cms";

class AnalyticsInfo extends React.Component {
    render() {
        return (
            <section
                className={`box ${this.props.className}`}
                style={{ paddingBottom: "30px", paddingTop: "50px" }}
                aria-labelledby="analytics-features-title"
            >
                <div className="container">
                    <h2 id="analytics-features-title" className="sr-only">ReelMetrics Analytics Platform Features</h2>
                    
                    <div className="row flex-row">
                        <div className="col-xs-12 col-sm-6 col-md-4 text-center">
                            <article className="question-box" itemScope itemType="https://schema.org/ItemList">
                                <figure className="question-box__media">
                                    <img
                                        src="assets/images/product_page_icon_ondemand_apps.svg"
                                        alt="On-Demand Analytics Applications for Casino Slot Management"
                                        className="img-responsive center-block"
                                        loading="lazy"
                                        width="120"
                                        height="120"
                                    />
                                </figure>
                                <h3 className="question-box__title" itemProp="name">
                                    <Cms
                                        content={this.props.cms_content}
                                        content_key="analytics_info_1"
                                        type="title"
                                    />
                                </h3>
                                <div
                                    className="question-box__body"
                                    style={{ minHeight: "0" }}
                                    itemProp="description"
                                >
                                    <Cms
                                        content={this.props.cms_content}
                                        content_key="analytics_info_1"
                                        type="text"
                                    />
                                </div>
                            </article>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-4 text-center">
                            <article className="question-box" itemScope itemType="https://schema.org/ItemList">
                                <figure className="question-box__media">
                                    <img
                                        src="assets/images/product_page_icon_prescriptive_apps.svg"
                                        alt="Prescriptive Analytics for Casino Slot Floor Optimization"
                                        className="img-responsive center-block"
                                        loading="lazy"
                                        width="120"
                                        height="120"
                                    />
                                </figure>
                                <h3 className="question-box__title" itemProp="name">
                                    <Cms
                                        content={this.props.cms_content}
                                        content_key="analytics_info_2"
                                        type="title"
                                    />
                                </h3>
                                <div
                                    className="question-box__body"
                                    style={{ minHeight: "0" }}
                                    itemProp="description"
                                >
                                    <Cms
                                        content={this.props.cms_content}
                                        content_key="analytics_info_2"
                                        type="text"
                                    />
                                </div>
                            </article>
                        </div>

                        <div className="col-xs-12 col-sm-6 col-md-4 text-center">
                            <article className="question-box" itemScope itemType="https://schema.org/ItemList">
                                <figure className="question-box__media">
                                    <img
                                        src="assets/images/product_page_icon_predictive_apps.svg"
                                        alt="Predictive Analytics for Casino Slot Performance Forecasting"
                                        className="img-responsive center-block"
                                        loading="lazy"
                                        width="120"
                                        height="120"
                                    />
                                </figure>
                                <h3 className="question-box__title" itemProp="name">
                                    <Cms
                                        content={this.props.cms_content}
                                        content_key="analytics_info_3"
                                        type="title"
                                    />
                                </h3>
                                <div
                                    className="question-box__body"
                                    style={{ minHeight: "0" }}
                                    itemProp="description"
                                >
                                    <Cms
                                        content={this.props.cms_content}
                                        content_key="analytics_info_3"
                                        type="text"
                                    />
                                </div>
                            </article>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default AnalyticsInfo;
